import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as DeviceManager from '../domain/device-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { PromiseType } from '../../types';

export type DeviceData = PromiseType<ReturnType<typeof DeviceManager.getSierraChildDeviceDetails>>;
type ContextState = Data<DeviceData>;
const Context = React.createContext<ContextState | null>(null);

function useSierraChildDeviceDetails(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useSierraChildDeviceDetails must be used within a SierraChildDeviceDetailsProvider');
    }
    return contextState;
}

const SierraChildDeviceDetailsProvider: React.FC<{ deviceId: string ;siteId: string; childDeviceId: string}> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'sierra-child-device-details',
        id: props.deviceId,
        dataFn: React.useCallback(() => DeviceManager.getSierraChildDeviceDetails(authHelper, props.deviceId,
            props.siteId, props.childDeviceId), [
            authHelper,
            props.deviceId, props.siteId, props.childDeviceId
        ]),
    });

    const deviceDetailsData = dataFromDataset(dataset);

    return <Context.Provider value={deviceDetailsData}>{props.children}</Context.Provider>;
};

const TestSierraChildDeviceDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { SierraChildDeviceDetailsProvider, TestSierraChildDeviceDataProvider, useSierraChildDeviceDetails };
